var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { State, Inject, Mutation } from 'vue-class-state';
import { toCamelCase } from '../../common/camelize';
import { checkLogin, createLock } from '../../common/decorators';
import { post } from '../../common/http';
import { toast } from '../../common/toast';
/**
 * 在追片单数据管理
 */
export class BingeState {
    constructor() {
        this.bingeWatchList = [];
        this.hasNextPage = true;
        this.hasFetched = false;
        this.hasInit = false;
        this.pageContext = {};
    }
    loadData(prefetched = false) {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.hasNextPage) {
                return;
            }
            try {
                if (txv.login.isLogin()) {
                    const accessDomain = location && location.host === 'v.qq.com' ? 'pbaccess.video.qq.com' : 'tpbaccess.video.qq.com';
                    const res = yield post(`//${accessDomain}/trpc.universal_backend_service.video_list.VideoListService/getRecallItem`, {
                        // 在追片单请求参数，写死，无需理解
                        page_params: {
                            data_key: 'album_id=mzc001005q5c1p8',
                            page_id: 'video_list_nav',
                            page_type: 'operation',
                            un_strategy_id: 'e5051021adb24a7c9583ddcf323a1b2a',
                        },
                        mod_infos: [
                            {
                                un_mod_id: '948869cc84c040af99012e56941d6f07',
                                un_module_key: '948869cc84c040af99012e56941d6f07_3_5',
                            },
                        ],
                        page_context: this.pageContext,
                    }, true, true);
                    if (res.ret === 0 && ((_c = (_b = (_a = res.data) === null || _a === void 0 ? void 0 : _a.recall_module['']) === null || _b === void 0 ? void 0 : _b.modules[0]) === null || _c === void 0 ? void 0 : _c.recall_items.recall_item)) {
                        const curList = res.data.recall_module[''].modules[0].recall_items.recall_item;
                        this.insertData(curList, res.data.has_next_page, res.data.page_context);
                        setTimeout(() => {
                            if (prefetched) {
                                this.loadData();
                            }
                        }, 0);
                    }
                    else {
                        throw new Error('获取在追片单数据失败');
                    }
                }
            }
            catch (error) {
                // @ts-ignore
                window.aegis.reportEvent({
                    name: 'GetBingeWatch Error',
                    ext1: JSON.stringify(error),
                });
            }
            finally {
                Mutation.commit(this, () => this.hasFetched = true);
            }
        });
    }
    delSingleBinge(attentKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield this.delRemoteBinge(attentKey);
            if (res.ret === 0) {
                this.delLocalBinge(attentKey);
            }
            else {
                toast.show({ text: '删除片单失败，请重试～', duration: 2000 });
            }
        });
    }
    delRemoteBinge(attentKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const accessDomain = location && location.host === 'v.qq.com' ? 'pbaccess.video.qq.com' : 'tpbaccess.video.qq.com';
            const delUrl = `//${accessDomain}/trpc.video_album_list.video_album_list_operation.VideoAlbumListOperationService/updateAlbum`;
            const res = yield post(delUrl, {
                operation: [
                    {
                        option: 1,
                        albumIds: [
                            {
                                id: 'mzc001005q5c1p8',
                                type: 1,
                            },
                        ],
                        data: {
                            videos: [
                                { dataKey: attentKey },
                            ],
                        },
                    },
                ],
            }, true, true);
            return res;
        });
    }
    insertData(data, hasNextpage, pageContext) {
        this.bingeWatchList = this.bingeWatchList.concat(toCamelCase(data));
        this.hasNextPage = hasNextpage;
        this.pageContext = pageContext;
    }
    delLocalBinge(attentKey) {
        console.log('Del local binge', attentKey);
        // eslint-disable-next-line max-len
        const deletedIndex = this.bingeWatchList.findIndex((item) => { var _a; return ((_a = item.itemParams) === null || _a === void 0 ? void 0 : _a.attentKey) === attentKey; });
        if (deletedIndex !== -1) {
            this.bingeWatchList.splice(deletedIndex, 1);
        }
    }
}
__decorate([
    State
], BingeState.prototype, "bingeWatchList", void 0);
__decorate([
    State
], BingeState.prototype, "hasNextPage", void 0);
__decorate([
    State
], BingeState.prototype, "hasFetched", void 0);
__decorate([
    createLock(),
    checkLogin
], BingeState.prototype, "loadData", null);
__decorate([
    checkLogin
], BingeState.prototype, "delRemoteBinge", null);
__decorate([
    Mutation
], BingeState.prototype, "insertData", null);
__decorate([
    Mutation
], BingeState.prototype, "delLocalBinge", null);
export const IBingeState = Inject('binge');
